import app, { Component } from 'apprun';
import { serializeObject, companies, users } from './api';
import { isValid, showSaveStatusMessage, lookup_en } from './utils';
import moment from 'moment';

export default class UserTerminateComponent extends Component {
  dateFmt = 'DD-MMM-YYYY';
  state = { picker: null, dispAffilDetail: false, isAgent: false, googleRecipients: [] };
  view = (state) => {
    if (!state) {return;}

    return (
      <div style={{ width: '400px' }}>
        <form id="userTerminateForm">
          <div class="list-group">
            <div class="list-group-item" >
                            Reason For Leaving:
              <select name="rlpReasonForLeaving" id="rlpReasonForLeaving" required="required" data-validate="Int-1" oninput={e => this.run('futureAffiliationChanged', e.target.value)} style={{ 'width':'200px' }} class='pull-right'>
                {lookup_en.ReasonForLeaving.filter(r=>r.id !==1202).map(r => <option value={r.id}>{r.value}</option>)}
              </select>
              <div id="rlpReasonForLeavingErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item" >
                            Future Affiliation:
              <select name="rlpFutureAffiliation" id="futureAffiliation" required="required" data-validate="Int-1" oninput={e => this.run('futureAffiliationChanged', e.target.value)} style={{ 'width':'200px' }} class='pull-right'>
                {lookup_en.FutureAffiliation.filter(r => !r.disabled).map(r => <option value={r.id}>{r.value}</option>)}
              </select>
              <div id="futureAffiliationErrMsg" class="text-danger"></div>
            </div>
            {
              state.dispAffilDetail
                ?
                <div class="list-group-item"  style={{ 'display': state.dispAffilDetail?'disp':'none' }} >
                                Future Affiliation details: <input id="futureAffiliationDetails" name="rlpFutureAffiliationDetail"class='pull-right'/>
                  <div id="futureAffiliationDetailsErrMsg" class="text-danger"></div>
                </div>
                :
                null
            }
            <input style={{ 'display':'none' }}/><input style={{ 'display':'none' }}/>
            <div class="list-group-item">
                            End Date: <input $pikaday autocomplete="off" id="endDate" name="rlpEndDate" class='pull-right' placeholder="DD-MMM-YYYY" data-validate="Date"/>
              <div id="endDateErrMsg" class="text-danger"></div>
            </div>
            {
              !state.isAgent
                ?
                <div class="list-group-item">
                                Transfer Google Drive Data:
                  <select name="rlpGoogleTransfer" id="rlpGoogleTransfer" required="required" oninput={e => this.run('txfrRequiredChange', e.target.value)} data-validate class='pull-right' >
                    <option value=" ">[select]</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                  <div id="rlpGoogleTransferErrMsg" class="text-danger"></div>
                  {
                    state.txfrRequired
                      ?
                      <div>
                        <br/>
                                        To:
                        <select name="rlpTransferee" id="rlpTransferee" required="required" data-validate="Int-1" style={{ 'width':'300px' }} class='pull-right'>
                          <option value="-1">[select]</option>
                          {state.googleRecipients.map(r =>
                            <option value={r.personID}>
                              {r.rlpOfficialFirstName + ' ' + r.rlpOfficialLastName + ' (' + r.displayEmailAddress + ')'}
                            </option>)}
                        </select>
                        <div id="rlpTransfereeErrMsg" class="text-danger"></div>
                      </div>
                      :''
                  }
                </div>
                :''
            }
          </div>
        </form>
        <div class="edit-buttons">
          <button class="btn btn-default btn-xs pull-right" onclick={()=>this.run('cancel')}>cancel</button>
                    &nbsp;
          <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('save')} >Terminate</button>
        </div>
      </div>
    );
  }

  update = {

    txfrRequiredChange: async (state, txfrRequired) => {
      state.txfrRequired = txfrRequired === '1';
      if (state.txfrRequired && !state.googleRecipients.length) {
        state.googleRecipients = await companies.getAllActiveNonAgents(state.companyID);
        const thisUserIndex = state.googleRecipients.findIndex(p => p.personID === state.personId);
        state.googleRecipients.splice(thisUserIndex, 1);
      }
      return state;
    },

    futureAffiliationChanged: (state, idx) => {
      const dispAffilDetail = idx === '384'; // check if Future Affiliation is 'Other/Independent'
      if (dispAffilDetail !== state.dispAffilDetail) {state.picker = null;}
      return { ...state, dispAffilDetail };
    },

    save: async (state) => {

      try{
        const formName = 'userTerminateForm';
        if (!isValid(formName)) {return;}
        const endDate = (document.getElementById('endDate') as HTMLInputElement).value.trim();

        if ( moment(state.startDate, this.dateFmt) > moment(endDate, this.dateFmt)) {
          const errMsg = document.getElementById('endDateErrMsg') as HTMLDivElement;
          errMsg.innerHTML = '* End date cannot be before Start date.';
          return;
        }

        const formData = serializeObject(document.getElementById(formName));
        formData['hdnP'] = state.personId;
        const result = await users.terminateUser(formData);
        showSaveStatusMessage('user');
        if (result) {this.run('#sub-panel-done', 'userTerminate');}
        return state;
      }catch{
        showSaveStatusMessage();
      }
      return state;
    },

    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    }
  };

  mounted = ({ state }) => {
    return {
      picker: null,
      dispAffilDetail: false,
      txfrRequired: false,
      isAgent: false,
      googleRecipients: [],
      ...state
    };
  };
}
